import { render, staticRenderFns } from "./FscInputVat.vue?vue&type=template&id=6a1d5444&"
import script from "./FscInputVat.vue?vue&type=script&lang=ts&"
export * from "./FscInputVat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports